import { render } from "./privateComponent.vue?vue&type=template&id=46c5bf20"
import script from "./privateComponent.vue?vue&type=script&lang=js"
export * from "./privateComponent.vue?vue&type=script&lang=js"

import "./privateComponent.vue?vue&type=style&index=0&id=46c5bf20&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"cartridges/int_guidedProductFinder/cartridge/client/default/js/components/privateComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46c5bf20"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46c5bf20', __exports__)) {
    api.reload('46c5bf20', __exports__)
  }
  
  module.hot.accept("./privateComponent.vue?vue&type=template&id=46c5bf20", () => {
    api.rerender('46c5bf20', render)
  })

}


export default __exports__